﻿import React, { useContext, useState, useEffect, Fragment } from 'react';

import { BookingFlowContext } from '../BookingFlowContext'
import { products, vehicles } from '../Endpoints'
import { validateFormObject } from '../Validation'

import { Heading } from '../partials/Heading'
import { BackNavigation, ReturnStepAfterVehicleStage } from '../partials/BackNavigation'

import { HtmlOutput } from '../../../../../Resources/Scripts/_Shared/elements/HtmlOutput'
import { Divider } from '../../../../../Resources/Scripts/_Shared/elements/Divider'
import { TwoColumnWrapper } from '../../../../../Resources/Scripts/_Shared/elements/ColumnWrapper'
import { InputWithLabel } from '../../../../../Resources/Scripts/_Shared/elements/InputWithLabel'
import { DropdownlistWithLabel } from '../../../../../Resources/Scripts/_Shared/elements/DropdownlistWithLabel'

const Vehicle = () => {
  const currentCountry = document.querySelector('html').getAttribute('country');
  const { bookingFlowContext, setBookingFlowContext } = useContext(BookingFlowContext);
  const formLang = {
    ...bookingFlowContext.episerver,
    ...bookingFlowContext.localization.global,
    ...bookingFlowContext.localization.createAccount,
    ...bookingFlowContext.localization.addVehicle
  };
  const defaultCountryCode = currentCountry === 'no' ? 'N' : currentCountry === 'se' ? 'S' : 'FIN';
  const defaultCountryCodes = [{ Id: 'S', Name: 'S' }, { Id: 'FIN', Name: 'FIN' }, { Id: 'N', Name: 'N' }, { Id: 'DK', Name: 'DK' }];
  const countryCodeOptions = [
    ...defaultCountryCodes.filter(cc => cc.Id === defaultCountryCode),
    ...defaultCountryCodes.filter(cc => cc.Id !== defaultCountryCode),
  ];

  for (const [value] of Object.entries(formLang.licensePlateCountryCodeOptions)) {
    if (value !== 'FIN' && value !== 'N' && value !== 'S' && value !== 'N' && value !== 'DK') countryCodeOptions.push({ Id: value, Name: value });
  };
  const isReservedProduct = bookingFlowContext.availableSteps.onlineBooking.formData.productSelection.item.Type === 'RESERVED';
  const maxLicensePlatesPerQuantity = bookingFlowContext.availableSteps.onlineBooking.formData.productSelection.item.MaxLicensePlatesPerQuantity ?? 0;
  const pooling = !!maxLicensePlatesPerQuantity > 0;
  const existingVehicleList = bookingFlowContext.availableSteps.addVehicle.formData ?? [];
  const selectedLang = document.querySelector('html').getAttribute('lang');
  const [validationErrors, setValidationErrors] = useState([]);
  const selectedSpotAmount = bookingFlowContext.availableSteps.onlineBooking.formData.numberOfParkingSpots.number;
  const [pending, setPending] = useState(true);
  const [vehicleList, setVehicleList] = useState(existingVehicleList);
  const [userVehicleList, setUserVehicleList] = useState([]);
  const [getVehicleListDone, setGetVehicleListDone] = useState(false)
  //const CountryCode = bookingFlowContext.country === 'se' ? 'S' : bookingFlowContext.country === 'fi' ? 'FIN' : 'N';

  const onChangeRegistrationNumberHandler = (index, value) => {
    const newVehicleList = vehicleList.map(listItem => {
      if (listItem.index === index)
        return { ...listItem, PlateText: value ? value.toUpperCase().split(' ').join('') : value, error: null, };
      return listItem;
    })

    setVehicleList(newVehicleList);
  };

  const onChangeCountryCodeHandler = (index, value) => {
    const newVehicleList = vehicleList.map(listItem => {
      if (listItem.index === index)
        return { ...listItem, CountryCode: value, error: null, };
      return listItem;
    })

    setVehicleList(newVehicleList);
  };

  const onChangeDescriptionTextHandler = (index, value) => {
    const newVehicleList = vehicleList.map(listItem => {
      if (listItem.index === index)
        return { ...listItem, Description: value ?? listItem.Description };
      return listItem;
    })

    setVehicleList(newVehicleList);
  };

  const onChangeSelectionHandler = (index, PlateText, CountryCode, Description) => {
    const newVehicleList = vehicleList.map(listItem => {
      if (listItem.index === index)
        //return { ...listItem, registrationNumber: id, descriptionText: value };
        return { ...listItem, PlateText, CountryCode, Description };
      return listItem;
    })

    setVehicleList(newVehicleList);
  };

  const addNewVehicleHandler = () => {
    //setVehicleList([...vehicleList, { index: generateGuid(), registrationNumber: '', descriptionText: '' }])
    setVehicleList([...vehicleList, { index: generateGuid(), PlateText: '', CountryCode: defaultCountryCode }])
  };

  const addVehicleHandler = async () => {
    if (vehicleList.length === 0)
      return;

    if (vehicleList.length > 0) {
      let validationError = null;
      setValidationErrors([]);

      const validatedVehicleList = vehicleList.map((vehicle) => {
        const lp = {
          licensePlate: { value: { text: vehicle.PlateText, elementType: 'licenseplate', multiple: true, error: null, countryCode: vehicle.CountryCode } }
        }
        let [formValidationError, cleanFormData] = validateFormObject(lp, formLang.errorMessages, bookingFlowContext.country);
        setValidationErrors(validationErrors => [...validationErrors, formValidationError])
        vehicle.error = cleanFormData.licensePlate.error;
        if (formValidationError) validationError = true;
        return vehicle
      });
      setVehicleList(validatedVehicleList);
      if (validationError) {
        setTimeout(() => {
          const firstInvalidElement = document.querySelector('[aria-invalid]').closest('label');
          if (firstInvalidElement) firstInvalidElement.scrollIntoView({ behavior: 'smooth' });
        }, 500);
        return
      }
      setPending(true)
      for (const vehicle of validatedVehicleList) {
        if (!userVehicleList.some(userVehicle => userVehicle.Id === vehicle.PlateText)) {
          const createVehicleResponse = await vehicles.createCustomerVehicle({ bookingController: bookingFlowContext.episerver.bookingController, form: { name: vehicle.Description, licensePlate: { plateText: vehicle.PlateText, countryCode: vehicle.CountryCode } } }, false, selectedLang);
          if (createVehicleResponse.status === 200) {
          } else {
            console.error(createVehicleResponse.errorMessage)
          }
        }
      }
      setPending(false);
    }
    setBookingFlowContext({
      ...bookingFlowContext,
      activeStep: ReturnStepAfterVehicleStage(bookingFlowContext),
      availableSteps: {
        ...bookingFlowContext.availableSteps,
        addVehicle: {
          ...bookingFlowContext.availableSteps.addVehicle,
          formData: vehicleList
        },
      },
    })
  };

  const removeVehicleListItemHandler = (indexToRemove) => {
    const newArr = [...vehicleList];
    newArr.splice(indexToRemove, 1);
    setVehicleList(newArr);
  }

  const generateGuid = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  useEffect(() => {
    setPending(bookingFlowContext.availableSteps.onlineBooking.order && getVehicleListDone ? false : true);
  }, [bookingFlowContext.availableSteps.onlineBooking.order])

  useEffect(() => {
    let isSubscribed = true;
    if (vehicleList.length === 0) {
      const blankPlaceholderList = [];

      if (isReservedProduct) {
        //blankPlaceholderList.push({ index: generateGuid(), registrationNumber: '', descriptionText: '' })
        blankPlaceholderList.push({ index: generateGuid(), PlateText: '', CountryCode: defaultCountryCode, Description: '' })
      } else {
        for (let i = 0; i < selectedSpotAmount; i++) {
          //blankPlaceholderList.push({ index: generateGuid(), registrationNumber: '', descriptionText: '' })
          blankPlaceholderList.push({ index: generateGuid(), PlateText: '', CountryCode: defaultCountryCode, Description: '' })
        }
      }

      setVehicleList(blankPlaceholderList);
  }
    else if (!isReservedProduct && vehicleList.length !== selectedSpotAmount) {
      const updatedPlaceholderList = vehicleList;

      if (vehicleList.length > selectedSpotAmount) {
        const newArrayLength = vehicleList.length - selectedSpotAmount;
        updatedPlaceholderList.splice(-(newArrayLength), newArrayLength);
      }
      else if (vehicleList.length < selectedSpotAmount) {
        for (let i = vehicleList.length; i < selectedSpotAmount; i++) {
          //updatedPlaceholderList.push({ index: generateGuid(), registrationNumber: '', descriptionText: '' })
          updatedPlaceholderList.push({ index: generateGuid(), PlateText: '', CountryCode: defaultCountryCode, Description: '' })
        }
      }

      setVehicleList(updatedPlaceholderList);
    }

    const getUserVehicleList = async () => {
      setPending(true);
      const allUserVehicles = await vehicles.getCustomerVehicles({ bookingController: bookingFlowContext.episerver.bookingController }, bookingFlowContext.useMockedData, selectedLang);
      setGetVehicleListDone(true);
      //console.log(bookingFlowContext.availableSteps.onlineBooking)
      if (allUserVehicles.status === 200 && isSubscribed && allUserVehicles.body !== null && allUserVehicles.body.length > 0) {
        if (bookingFlowContext.availableSteps.onlineBooking.order) setPending(false);
        const userVehiclesPlusCreateOption = [];

        for (let i = 0; i < allUserVehicles.body.length; i++) {
          const singleVehicle = allUserVehicles.body[i];

          userVehiclesPlusCreateOption.push({
            Id: singleVehicle.LicensePlate.PlateText,
            Description: singleVehicle.Description ?? '',
            Text: singleVehicle.Description ? `${singleVehicle.LicensePlate.PlateText} (${singleVehicle.Description})` : singleVehicle.LicensePlate.PlateText,
            CountryCode: singleVehicle.LicensePlate.CountryCode
          });
        }

        userVehiclesPlusCreateOption.push({ Text: bookingFlowContext.localization.addVehicle.buttons.addNewVehicle, Id: 'NEW' });

        setUserVehicleList(userVehiclesPlusCreateOption);
      } else if (isSubscribed) {
        if (bookingFlowContext.availableSteps.onlineBooking.order) setPending(false);
      }
    }

    if (userVehicleList.length === 0)
      getUserVehicleList();

    return () => isSubscribed = false;
  }, [])

  const dataBookingFlowStep = bookingFlowContext.episerver.productType === 1 ? "ltp-addvehicle" : bookingFlowContext.episerver.productType === 2 ? "stp-addvehicle" : null;

  return (
    <div className="bookingflowpage__app bookingflowpage__app--unreservedproduct">
      <BackNavigation />
      <Heading />
      <div className="single-step single-step--booking">
        <h2>{bookingFlowContext.localization.addVehicle.heading}</h2>

        <h3 className="left nomargin">{bookingFlowContext.localization.addVehicle.registerheading}</h3>
        {isReservedProduct && <p className="margin"><HtmlOutput html={bookingFlowContext.localization.addVehicle.registerreservedtext} /></p>}
        {!isReservedProduct && <p className="margin"><HtmlOutput html={bookingFlowContext.localization.addVehicle.registerunreservedtext} /></p>}

        {vehicleList.length > 0 &&
          vehicleList.map((singleVehicle, index) =>
            <ProductItem
              rowIndex={index}
              singleVehicle={singleVehicle}
              onChangeRegistrationNumberHandler={onChangeRegistrationNumberHandler}
              onChangeCountryCodeHandler={onChangeCountryCodeHandler}
              onChangeDescriptionTextHandler={onChangeDescriptionTextHandler}
              onChangeSelectionHandler={onChangeSelectionHandler}
              userVehicleList={userVehicleList}
              formData={bookingFlowContext.availableSteps.addVehicle.formData}
              value={singleVehicle}
              validationError={validationErrors.length ? validationErrors[index] : null}
              bookingFlowContext={bookingFlowContext}
              key={singleVehicle.index}
              pending={pending}
              isReservedProduct={isReservedProduct}
              pooling={pooling}
              defaultCountryCode={defaultCountryCode}
              countryCodeOptions={countryCodeOptions}
              removeVehicleListItem={vehicleList.length > (pooling ? selectedSpotAmount : 1) ? () => removeVehicleListItemHandler(index) : null}
            />
          )
        }

        {(isReservedProduct || (pooling && vehicleList.length < (maxLicensePlatesPerQuantity * selectedSpotAmount))) && (
          <div>
            <button className="single-step__small-button" onClick={addNewVehicleHandler}>{bookingFlowContext.localization.addVehicle.buttons.addNewVehicle}</button>
            <Divider />
          </div>
        )}

        <button className="single-step__button single-step__button--next" data-booking-flow-step={dataBookingFlowStep} disabled={pending || vehicleList.filter(item => (item.PlateText.length === 0 || item.PlateText === '00000000-0000-0000-0000-000000000000')).length > 0} onClick={addVehicleHandler}>
          {bookingFlowContext.localization.global.buttons.nextStep}
        </button>
      </div>
    </div>
  )
}

const ProductItem = ({ countryCodeOptions, onChangeCountryCodeHandler, defaultCountryCode, validationError, value, rowIndex, singleVehicle, onChangeRegistrationNumberHandler, onChangeDescriptionTextHandler, onChangeSelectionHandler, userVehicleList, formData, bookingFlowContext, pending, isReservedProduct, pooling, removeVehicleListItem }) => {

  const [showForm, setShowForm] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState({ item: { Text: bookingFlowContext.localization.addVehicle.buttons.selectVehicle, Id: '00000000-0000-0000-0000-000000000000' } });
  const [countryCode, setCountryCode] = useState({ item: { Name: defaultCountryCode, Id: defaultCountryCode }, required: false, elementType: "select" });
  
  useEffect(() => {
    if (!formData || !formData.length || selectedVehicle.item.PlateText) return;
    if (formData[0].PlateText) setSelectedVehicle({item: formData[0]});
  }, [formData]) 

  useEffect(() => {
    if (userVehicleList.length === 0 || pending)
      return;

    // const formDataItem = formData.filter(option => option.Id === singleVehicle.registrationNumber)

    if (selectedVehicle.item.Id === 'NEW') {
      setShowForm(true);
      //index, PlateText, CountryCode, Description
      //if (formData && formData.find(item => item.index === singleVehicle.index)?.registrationNumber === singleVehicle.registrationNumber)
      onChangeSelectionHandler(singleVehicle.index, '', countryCode.item.Id, '')
      return;
    }
    else if (selectedVehicle.item.Id !== 'NEW') {
      setShowForm(false);
      //onChangeSelectionHandler(singleVehicle.index, selectedVehicle.item.Id, selectedVehicle.item.Description)
      onChangeSelectionHandler(singleVehicle.index, selectedVehicle.item.Id, selectedVehicle.item.CountryCode, selectedVehicle.item.Description)
      return;
    }

  }, [selectedVehicle])

  useEffect(() => {
    if (userVehicleList.length === 0 || !formData || pending)
      return;

    //const vehicleInList = userVehicleList.filter(option => option.Id === singleVehicle.registrationNumber);
    const vehicleInList = userVehicleList.filter(option => option.Id === singleVehicle.PlateText);

    if (vehicleInList.length === 1) {
      setSelectedVehicle({ item: vehicleInList[0] });
      setShowForm(false);
    }
    //else if (singleVehicle.registrationNumber.length > 0) {
    else if (singleVehicle.PlateText.length > 0) {
      setSelectedVehicle({ item: { Text: bookingFlowContext.localization.addVehicle.buttons.addNewVehicle, Id: 'NEW' } });
      setShowForm(true);
    }

  }, [userVehicleList])

  useEffect(() => {
    onChangeCountryCodeHandler(singleVehicle.index, countryCode.item.Id)
  }, [countryCode])

  return (
    <React.Fragment>
      <Divider />
      {(!isReservedProduct && !pooling) && <h3 className="left nomargin">{`${bookingFlowContext.localization.onlineBooking.spotselection} ${rowIndex + 1}`}</h3>}
      {(pending || userVehicleList.length > 0) && <TwoColumnWrapper>
        <DropdownlistWithLabel text={bookingFlowContext.localization.addVehicle.buttons.registeredvehicles} options={userVehicleList} value={selectedVehicle} setValue={setSelectedVehicle} loading={pending} />
      </TwoColumnWrapper>}
      {(!pending && (userVehicleList.length === 0 || showForm)) && <TwoColumnWrapper modifier="skipmargintop">
        <TwoColumnWrapper modifier="equal">
          <InputWithLabel value={value} autoFocus={true} maxLength={10} toUpperCase={true} inputType="text" text={bookingFlowContext.localization.addVehicle.registrationNumber} onChange={onChangeRegistrationNumberHandler} index={singleVehicle.index} placeholder={bookingFlowContext.localization.addVehicle.registrationNumberPlaceholder} defaultText={singleVehicle.PlateText} />
          <DropdownlistWithLabel dropdownId="countryCodeOptions" text={bookingFlowContext.localization.addVehicle.countryCode} options={countryCodeOptions} optionText="Name" value={countryCode} setValue={setCountryCode} />
        </TwoColumnWrapper>
        <InputWithLabel maxLength={255} inputType="text" text={bookingFlowContext.localization.addVehicle.descriptionText} onChange={onChangeDescriptionTextHandler} index={singleVehicle.index} placeholder={bookingFlowContext.localization.addVehicle.descriptionTextPlaceholder} defaultText={singleVehicle.descriptionText} />
      </TwoColumnWrapper>}
      {removeVehicleListItem !== null && (
        <button className="single-step__link single-step__link--remove single-step__link--margin" onClick={removeVehicleListItem}>
          {bookingFlowContext.localization.addVehicle.remove}
        </button>
      )}
    </React.Fragment>
  )
}

export default Vehicle;
